// extracted by css-extract-rspack-plugin
export default {"copyright":"Copyright-module__copyright--Igl3G"};